// BrainPicker — escolhe o "cérebro" (LLM) do dispatch: Cloud (default, via
// Worker, sem Ollama) ou Local (Ollama/LM Studio na máquina). A execução das
// tools é sempre no Mac. value = brain object | null (null = cloud default).

import TouchButton from '../ui/TouchButton.jsx';

export default function BrainPicker({ value, onChange }) {
  const kind = value?.kind === 'local' ? 'local' : 'cloud';
  return (
    <div role="group" aria-label="Cérebro" className="flex gap-2">
      <TouchButton
        size="sm"
        variant={kind === 'cloud' ? 'primary' : 'secondary'}
        aria-pressed={kind === 'cloud'}
        onClick={() => onChange({ kind: 'cloud' })}
      >
        Cloud
      </TouchButton>
      <TouchButton
        size="sm"
        variant={kind === 'local' ? 'primary' : 'secondary'}
        aria-pressed={kind === 'local'}
        onClick={() => onChange({ kind: 'local' })}
      >
        Local (Ollama)
      </TouchButton>
    </div>
  );
}
